import { Button, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as ArrowLeft } from "assets/icons/arrow-left-with-line.svg";
import { ReactComponent as WarningInfo } from "assets/icons/warning-primary-circule.svg";

const Info = ({ handleBankInfo }) => {
  const { t } = useTranslation();
  return (
    <Typography.Link onClick={() => handleBankInfo(true)}>
      <div className=" border border-blue--5 rounded-lg">
        <div className="py-2 px-3 flex items-center bg-blue--7 ">
          <WarningInfo className="[&>path]:fill-blue-0" />
          <span className=" caption-12px-bold mr-1 text-blue-0">
            {t("payment.receipt-info")}
          </span>
        </div>
        <div className="text-gray-3 body-14px-regular p-3 bg-gray--13 flex flex-col ">
          {t("payment.receipt-description")}
          <Button
            icon={<ArrowLeft className="mr-2" />}
            className="default-button-small-with-icon  flex-row-reverse w-fit self-end mt-3"
          >
            {t("payment.show-banks-list")}
          </Button>
        </div>
      </div>
    </Typography.Link>
  );
};
export default Info;
